import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const RcmndtnDetailsSkeleton = (props) => {
  const { dataIndex, windowWidth } = props;
  return (
    <div
      className="selected-recommendation"
      style={
        dataIndex <= 4
          ? { left: '100%', right: 'unset' }
          : { right: '100%', left: 'unset' }
      }
    >
      <div
        className="card_content"
        style={windowWidth <= 878 ? { marginLeft: '4px' } : {}}
      >
        <div className="mb-8">
          <Skeleton
            borderRadius="1rem"
            height="15px"
            width="200px"
            margin="0"
          />
        </div>
        <div className="mb-8">
          <Skeleton
            borderRadius="1rem"
            height="15px"
            width="150px"
            margin="0"
            />

          <div>
            <Skeleton
              borderRadius="1rem"
              height="15px"
              width="100px"
              margin="0"
            />
          </div>
          <div>
            <Skeleton
              borderRadius="1rem"
              height="15px"
              width="100px"
              margin="0"
            />
          </div>
          <div>
            <Skeleton
              borderRadius="1rem"
              height="15px"
              width="100px"
              margin="0"
            />
          </div>
          <div>
            <Skeleton
              borderRadius="1rem"
              height="15px"
              width="100px"
              margin="0"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default RcmndtnDetailsSkeleton;
